$(document).ready(function () {
    if ($('.wrapper').outerWidth() < 481) {
        rfs.mobile.init();
    }

    if (window.outerWidth < 481) {
        var MOBILE_DESKTOP_CLASS = 'mobile-desktop';
        var COEFFICIENT = 2.5;
        //todo костыль на исправления десктопной версии на мобилке
        var indexEventWidth = $('.index-page').innerWidth() + 'px';

        $('.js-index-event').css({width: indexEventWidth, margin: '0 auto 56px'});
        $('.js-event-slider-items').css({margin: 0});
        $('.match-textbroadcast').css({padding: '37px 39px'});

        var $wrapper = $('.wrapper');
        if ($wrapper && $wrapper.length > 0 && ($wrapper.innerWidth() / window.outerWidth > COEFFICIENT)) {
            $('.js-match-members-add-desktop-mobile').addClass(MOBILE_DESKTOP_CLASS);
            $('.js-match-card-row-add-desktop-mobile').addClass(MOBILE_DESKTOP_CLASS);
            $('.profile-header').addClass('dsk');
            $('.national-header').addClass('dsk');
            $('.members-block-cont-player').addClass('dsk');
        }
    }
    rfs.menu.init();
    rfs.toTop.init();
    rfs.slider.init();
    rfs.select.init();
    rfs.dropdown.init();
    rfs.tabs.init();
    rfs.checkbox.init();
    rfs.accordion.init();
    rfs.descmore.init();
    rfs.sorttable.init();
    //JS Главная страницы
    if ($('.js-news-slider').length) {
        rfs.mainSlider.init();
    }
    if ($('.main-slider').length) {
        rfs.mobileSlider.init();
    }
    //JS для шахматки
    if ($('table.chess').length) {
        var activeColor = $('table.chess').data('hover-bg') || '#9bbd69';

        $('table.chess').find('.chess-cell').hover(
            function () {
                var versus_team_id = $(this).data('versus-team-id');
                $(this).parents('table.chess').find('.versus-team-' + versus_team_id).css('backgroundColor', activeColor);
            },
            function () {
                var versus_team_id = $(this).data('versus-team-id');
                $(this).parents('table.chess').find('.versus-team-' + versus_team_id).css('backgroundColor', 'transparent');
            }
        );
    }
});

var MOBILE_DEVICE_REGEXP = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
var rfs = {};
rfs.menu = {
    'init': function () {
        rfs.menu.main.init();
        rfs.menu.sub.init();
        rfs.menu.side.init();
    },
    'main': {
        'params': {
            delay: 300
        },
        'init': function () { //инициализация для выпадающего меню
            var menu = $('#RFSMainMenu');
            $(menu).find(' > li').hover(
                function () {
                    var item = this,
                        showEl = $(this).data('item-id');
                    $('.header').addClass('open-menu');
                    $('#' + showEl).parent().addClass('show');
                    $(menu).find(' > li.hover').removeClass('hover');
                    $(this).addClass('hover');
                },
                function () {
                    var item = this,
                        showEl = $(item).data('item-id');

                    $('.header.open-menu').removeClass('open-menu');
                    $('#' + showEl).parent().removeClass('show');
                    $(this).removeClass('hover');
                }
            );
            $('#RFSMainMenuEng>li.has-submenu').each(function () {
                if ($(this) && $(this).find('ul.submenu').length) {
                    $(this).find('ul.submenu').hide(0);
                    $(this).hover(function () {
                        $(this).find('ul.submenu').show(0, function () {
                            $(this).addClass('fadeshow');
                        });
                    }, function () {
                        $(this).find('ul.submenu').removeClass('fadeshow');
                        var el = this;
                        setTimeout(function () {
                            $(el).find('ul.submenu').hide();
                        }, 250);
                    });
                }
            });
            $(window).scroll(function () {
                if (!$('body').hasClass('always-fixed')) {
                    if (window.scrollY > 91) {
                        $('body').addClass('fixed-menu');
                        $('.header').addClass('fixed');
                    } else {
                        $('body').removeClass('fixed-menu');
                        $('.header').removeClass('fixed');
                    }
                }
            });

            if (!$('body').hasClass('always-fixed')) {
                if (window.scrollY > 91) {
                    $('body').addClass('fixed-menu');
                    $('.header').addClass('fixed');
                } else {
                    $('body').removeClass('fixed-menu');
                    $('.header').removeClass('fixed');
                }
            }
        }
    },
    'sub': {
        'init': function () { //инициализация для выпадающего меню
            $("#RFSMainSubMenu>li").each(function () {
                $(this).click(function (event) {
                    event = event || window.event;
                    $(this).parent().children('li.active').removeClass('active');
                    if (!$(this).hasClass('has-submenu')) {
                        $(this).parent().find('li.has-submenu.open').each(function () {
                            rfs.menu.sub.toggle(this, 250);
                        });
                    } else if ($(this).find('ul.submenu').length) {
                        if ($(event.target).parent().hasClass('has-submenu')) {
                            if (!$(event.target).hasClass('submenu')) {
                                var menu = $(this).parents('#RFSMainSubMenu');
                                if ($(menu).find('ul.submenu.active').length) {
                                    var el = $(this);
                                    $(menu).find('ul.submenu.active').each(function () {
                                        if ($(this).parent().get(0) !== $(el).get(0)) {
                                            rfs.menu.sub.toggle($(this).parent(), 250, function () {
                                                rfs.menu.sub.toggle(el, 250);
                                            });
                                        } else {
                                            rfs.menu.sub.toggle(el, 250);
                                        }
                                    });
                                } else {
                                    rfs.menu.sub.toggle(this, 250);
                                }
                            }
                        } else {
                            rfs.menu.sub.toggleSubItem(event.target, $(this).find('ul.submenu'));
                        }
                    }
                    $(this).addClass('active');
                });
            });
        },
        'toggle': function (el, delay, callback) {
            $(el).toggleClass('open');
            var submenu = $(el).find('ul.submenu');
            if (!$(submenu).hasClass('active')) {
                $(el).parents('.main-title-menu').animate({'height': '77px'}, delay);
                $(submenu)
                    .addClass('active')
                    .show(0)
                    .animate({
                        'height': '38px',
                        'opacity': 1
                    }, delay);
                if ($(el).hasClass('js-directly-load')) {
                    $(submenu).find('>li:last-child>a').click();
                }
            } else {
                $(el).parents('.main-title-menu').animate({'height': '41px'}, delay);
                $(submenu)
                    .animate({
                        'height': '0px',
                        'opacity': 0
                    }, delay, function () {
                        $(this).hide(0, function () {
                            $(this).removeClass('active');
                            if (callback) {
                                callback();
                            }
                        });
                    });
            }
        },
        'toggleSubItem': function (el, submenu) {
            $(submenu).find('li.active').removeClass('active');
            $(el).parent().addClass('active');
        }
    },
    'side': {
        'init': function () {
            if ($('.sidebar-menu').length) {
                $('.sidebar-menu').each(function () {
                    var menu = this;
                    $(this).find('a').click(function () {
                        if (!$(this).hasClass('active')) {
                            $(menu).find('ul:not(.submenu)').children('li.active').removeClass('active');
                            $(this).parent().addClass('active');
                        }
                        if ($(this).data('tab') && !$(this).attr('href')) {
                            var tab = $(this).data('tab');
                            $('#RFSContTabs').find('.rfs-cont-tab.active')
                                .removeClass('active')
                                .fadeOut(400, function () {
                                    $('#' + tab)
                                        .addClass('active')
                                        .fadeIn(400);
                                });
                        }
                    });
                    $(this).find('li.has-submenu>a').click(function () {
                        var parent = $(this).parent(),
                            submenu = $(parent).find('ul.submenu');
                        $(parent).addClass('that');
                        if ($(menu).find('li.has-submenu.open:not(.that)').length) {
                            var open_menus = $(menu).find('li.has-submenu.open:not(.that)>ul.submenu'),
                                open_menus_count = $(open_menus).length,
                                callback;
                            for (var i = 0; i < open_menus_count; i++) {
                                callback = null;
                                if (i == (open_menus_count - 1) && !$(parent).hasClass('open')) {
                                    callback = function () {
                                        rfs.menu.side.open(submenu);
                                    }
                                }
                                rfs.menu.side.close(open_menus[i], callback);
                            }
                        } else {
                            if ($(parent).hasClass('open')) {
                                rfs.menu.side.close(submenu);
                            } else {
                                rfs.menu.side.open(submenu);
                            }
                        }
                    });
                    $(this).find('li.has-submenu ul.submenu').find('a').click(function () {
                        $(this).parents('ul.submenu').find('li.active').removeClass('active');
                        $(this).parent().addClass('active');
                    });
                });
            }
        },
        'close': function (submenu, callback) {
            $(submenu).slideUp(300, function () {
                $(submenu).parent().removeClass('open');
                if (callback) {
                    callback();
                } else {
                    rfs.menu.side.clear(submenu);
                }
            });
        },
        'open': function (submenu) {
            $(submenu).parent().addClass('open');
            $(submenu).slideUp(0, function () {
                // TODO:
                /*
                * Пока что захардкодили на открытии sub-menu, что если у нас страничка включает в себя путь /committees,
                * то мы не выполняем скролл, а иначе (в дефолтном случае) выполняем скролл до верха
                * Захардкожено так, чтобы не сломать логику на всех sub-menu
                */
                var COMITTEES_PATH = '/committees';
                var isCommitteesPathExists = window.location.pathname.includes(COMITTEES_PATH);
                if (!isCommitteesPathExists) {
                    $('html, body').animate({scrollTop: 92}, 300, false);
                }

                $(this).slideDown(300, function () {
                    rfs.menu.side.clear(submenu);
                });
            });
        },
        'clear': function (submenu) {
            $(submenu).parents('.sidebar-menu').find('li.that').removeClass('that');
        }
    }
};
rfs.toTop = {
    'init': function () {
        $('.scroll-to-top-btn').click(function () {
            $('html, body').animate({
                scrollTop: 0
            }, 400, false);
        });
    }
};
rfs.slider = {
    'widgets': [],
    'init': function () {
        if ($('.rfs-slider').length) {
            $('.rfs-slider').each(function (k) {
                var already = false,
                    el = this;
                $(rfs.slider.widgets).each(function () {
                    if ($(this).get(0) == $(el).get(0)) {
                        already = true;
                        return false;
                    }
                });
                if (!already) {
                    rfs.slider.widgets.push({'el': this, sliding: false});
                    $(this).find('>.rfs-slider-left').click(function () {
                        if (!rfs.slider.widgets[k].sliding) {
                            rfs.slider.slide(this, 'prev', k);
                        }
                    });
                    $(this).find('>.rfs-slider-right').click(function () {
                        if (!rfs.slider.widgets[k].sliding) {
                            rfs.slider.slide(this, 'next', k);
                        }
                    });
                    if ($(this).find('.rfs-slider-indicators-cont').length) {
                        var indicators_cont = $(this).find('.rfs-slider-indicators-cont'),
                            indicators = $(indicators_cont).find('.rfs-slider-indicator'),
                            delay = 700;
                        if ($(indicators_cont).data('indicator-main-delay') !== undefined) {
                            delay = $(indicators_cont).data('indicator-main-delay');
                        }
                        $(indicators).click(function () {
                            if (!rfs.slider.widgets[k].sliding) {
                                if (rfs.slider.widgets[k].timer && $(rfs.slider.widgets[k].el).data('autoslide')) {
                                    rfs.slider.widgets[k].pauseTimer = true;
                                    setTimeout(function () {
                                        rfs.slider.widgets[k].pauseTimer = false;
                                    }, 10000); //таймер снова запустится через 10сек
                                }
                                if (!$(this).hasClass('active')) {
                                    var old_index = 0, new_index = 0;
                                    $(this).addClass('new');
                                    $(indicators).each(function (j) {
                                        if ($(this).hasClass('active')) {
                                            $(this).removeClass('active');
                                            old_index = j;
                                        }
                                        if ($(this).hasClass('new')) {
                                            $(this)
                                                .removeClass('new')
                                                .addClass('active');
                                            new_index = j;
                                        }
                                    });
                                    if (old_index < new_index && !rfs.slider.widgets[k].sliding) {
                                        rfs.slider.slide($(rfs.slider.widgets[k].el).find('>.rfs-slider-right'), 'next', k, {
                                            'i': 0,
                                            'count': Math.abs(new_index - old_index),
                                            'delay': delay
                                        });
                                    } else if (!rfs.slider.widgets[k].sliding) {
                                        rfs.slider.slide($(rfs.slider.widgets[k].el).find('>.rfs-slider-left'), 'prev', k, {
                                            'i': 0,
                                            'count': Math.abs(new_index - old_index),
                                            'delay': delay
                                        });
                                    }
                                }
                            }
                        });
                    }
                    if ($(this).data('view-cont-selector')) {
                        $(this).find('.rfs-slider-slide').each(function (index) {
                            $(this).click(function () {
                                $($(rfs.slider.widgets[k].el).data('view-cont-selector')).data('open-index', index);
                            });
                        });
                    }
                    if ($(this).data('autoslide')) {
                        rfs.slider.setTimer(k);
                    }
                    if ($(this).data('end')) {
                        setTimeout(function () {
                            $(rfs.slider.widgets[k].el).find('>.rfs-slider-right').click();
                        }, 800);
                    }
                    if ($(this).data('first-step')) {
                        var default_data = {
                                'slideStep': $(this).data('slideStep'),
                                'slideViews': $(this).data('slideViews')
                            },
                            new_data = {'slideStep': 1, 'slideViews': 1, 'firstStep': $(this).data('firstStep')};
                        $(this).data(new_data);
                        rfs.slider.slide($(this).find('>.rfs-slider-right'), 'next', k, {
                            'delay': 0, 'i': 0,
                            'count': $(this).data('firstStep'),
                            'callback': function () {
                                $(rfs.slider.widgets[k].el).data(default_data);
                            }
                        });
                    }
                }
            });
        }
    },
    'setTimer': function (widget_index) {
        var slider = rfs.slider.widgets[widget_index].el;
        rfs.slider.widgets[widget_index].pauseTimer = false;
        rfs.slider.widgets[widget_index].timer = setInterval(function () {
            if (!rfs.slider.widgets[widget_index].pauseTimer && !rfs.slider.widgets[widget_index].sliding) {
                rfs.slider.slide($(slider).find('>.rfs-slider-right'), 'next', widget_index);
            }
        }, $(slider).data('autoslide'));
    },
    'slide': function (el, param, widget_index, more) {
        rfs.slider.widgets[widget_index].sliding = true;
        var slider = rfs.slider.widgets[widget_index].el,
            cont = $(slider).find('.rfs-slider-cont')[0];
        var position_params = rfs.slider.getPositionParams(cont, param, $(slider).data());
        if ($(slider).find('.rfs-slider-indicators-cont').length) {
            var indicators_cont = $(slider).find('.rfs-slider-indicators-cont'),
                indicators = $(indicators_cont).find('.rfs-slider-indicator');
            $(indicators).removeClass('active');
            if (param == 'next' && $($(indicators_cont).find('.rfs-slider-indicator')[position_params.next_shift]).length) {
                $(indicators[position_params.next_shift]).addClass('active');
            } else {
                $(indicators[position_params.next_shift - 1]).addClass('active');
            }
            if (rfs.slider.widgets[widget_index].carousel) {
                $(slider).find('.rfs-slider-indicators-cont').find('.rfs-slider-indicator:first-child').addClass('active');
            }
        }
        if (param == 'next') {
            $(slider).find('>.rfs-slider-left').show();
            if (position_params.hide_btn) {
                $(el).hide();
            }
        } else {
            $(slider).find('>.rfs-slider-right').show();
            if (position_params.hide_btn) {
                $(el).hide();
            }
        }
        var delay = 700;
        if ($(rfs.slider.widgets[widget_index].el).data('delay')) {
            delay = $(rfs.slider.widgets[widget_index].el).data('delay');
        } else if (more && more.delay !== undefined) {
            delay = more.delay;
        } else if (more) {
            delay = delay / more.count;
        }
        $(position_params.all[position_params.next_shift]).addClass('selected');
        setTimeout(function () {
            $(position_params.all[position_params.next_shift]).removeClass('selected');
        }, delay);
        if ($(slider).find('.rfs-slider-indicators-cont.rfs-slider').length) {
            rfs.slider.slideIndicatorSlider(widget_index, param);
        }
        $(cont).css({
            'left': position_params.new_pos + 'px'
        }).delay(delay).queue(function (next) {
            rfs.slider.widgets[widget_index].sliding = false;
            if (rfs.slider.widgets[widget_index].carousel) {
                $(cont).css('left', 0);
                $(cont).find('.rfs-slider-slide.rfs-sliding').removeClass('rfs-sliding');
                $(position_params.all[(position_params.all.length - 1)]).remove();
                rfs.slider.widgets[widget_index].carousel = false;
            } else if (param == 'next' && position_params.hide_btn && $(slider).data('autoslide')) {
                rfs.slider.goToFirst(widget_index, position_params);
            }
            if (more && (++more.i < more.count) && !rfs.slider.widgets[widget_index].sliding) {
                rfs.slider.slide(el, param, widget_index, more);
            } else {
                if (more && more.callback) {
                    more.callback();
                }
            }
            next();
        });
    },
    'slideIndicatorSlider': function (widget_index, param) {
        var slides = $(rfs.slider.widgets[widget_index].el).find('>.rfs-slider-cont').find('.rfs-slider-slide'),
            indicator_slider = $(rfs.slider.widgets[widget_index].el).find('.rfs-slider-indicators-cont.rfs-slider'),
            indicators = $(indicator_slider).find('.rfs-slider-slide');
        if (param == 'prev') {
            var need_index = null;
            $(slides).each(function (k) {
                if (!$(this).hasClass('rfs-sliding') && !need_index) {
                    need_index = k;
                }
            });
            if ($(indicators[(need_index - 1)]).length && $(indicators[(need_index - 1)]).hasClass('rfs-sliding')) {
                rfs.slider.slide($(indicator_slider).find('.rfs-slider-left'), 'prev', (widget_index + 1), {});
            }
        } else {
            var current_index = null,
                data = $(indicator_slider).data(),
                already_shift = $(indicator_slider).find('.rfs-sliding').length;
            $(indicators).each(function (k) {
                if ($(this).hasClass('active') && !current_index) {
                    current_index = k;
                }
            });
            if ((current_index - data.slideViews - already_shift + 1) == 0) {
                rfs.slider.slide($(indicator_slider).find('.rfs-slider-right'), 'next', (widget_index + 1), {});
            }
        }
    },
    'goToFirst': function (widget_index, position_params) {
        var slider = rfs.slider.widgets[widget_index].el,
            cont = $(slider).find('.rfs-slider-cont');
        var clone = $(cont).find('.rfs-slider-slide:first-child').clone().removeClass('rfs-sliding');
        $(position_params.all[(position_params.all.length - 1)]).after(clone);
        rfs.slider.widgets[widget_index].carousel = true;
    },
    'getPositionParams': function (cont, param, widget_data) {
        var count_slide = widget_data['slideStep'],
            count_views = widget_data['slideViews'],
            all = $(cont).find('.rfs-slider-slide'), //все сдвигаемые элементы
            already_shift = $(cont).find('.rfs-sliding').length, //уже сдвинуто
            new_pos = parseInt($(cont).css('left'), 10),
            limiter = (param == 'next') ? (already_shift + count_slide) : (already_shift - count_slide);
        if (param == 'next') {
            $(all).each(function (k) {
                if (k >= already_shift && k < limiter && k < ($(all).length - count_views)) {
                    $(this).addClass('rfs-sliding');
                    new_pos -= rfs.slider.getWidthEl(this);
                }
            });
        } else {
            $(all).filter('.rfs-sliding').each(function (k) {
                if ($(this).hasClass('rfs-sliding') && k < already_shift && k >= limiter) {
                    $(this).removeClass('rfs-sliding');
                    new_pos += rfs.slider.getWidthEl(this);
                }
            });
        }
        return {
            'all': all,
            'new_pos': new_pos,
            'count_slide': count_slide,
            'count_views': count_views,
            'next_shift': (param == 'next') ? ((already_shift == 0) ? count_slide : (already_shift + count_slide)) : already_shift,
            'hide_btn': (($(all).filter('.rfs-sliding').length == 0 && param == 'prev') || (($(all).filter('.rfs-sliding').length + count_views) == $(all).length && param == 'next'))
        };
    },
    'getWidthEl': function (el) {
        var width = parseInt($(el).outerWidth(), 10);
        width += parseInt($(el).css('marginLeft'), 10);
        width += parseInt($(el).css('marginRight'), 10);
        return width;
    }
};
rfs.tabs = {
    'init': function () {
        $('.rfs-tabs').each(function () {
            var cont;
            if ($(this).data('cont-id')) {
                cont = $('#' + $(this).data('cont-id'));
            } else {
                cont = $($(this).data('cont-selector'));
            }

            $(this).find('li').click(function () {
                $(this).parent().find('li.active').removeClass('active');
                $(this).addClass('active');
                if ($(this).data('show-all')) {
                    $(cont).children('.rfs-tab-cont').show(0);
                } else {
                    $(cont).find('.rfs-tab-cont').hide(0);
                    if ($(this).data('tab-id')) {
                        $(cont).find('#' + $(this).data('tab-id')).show(0);
                    } else if ($(this).data('tab-selector')) {
                        $(cont).find($(this).data('tab-selector')).show(0);
                    }
                    $(document).trigger('tabchange');
                }
                $('.js-timeline-wrapper').each(function () {
                    $(this).data('timelineWidth', $(this).timelineWidth());
                });
            });
        });
    }
};
rfs.select = {
    'delay': 100,
    'init': function () {
        $('select').not('.js-select2').each(function (i) {
            if (!$(this).hasClass('chosen') && !$(this).hasClass('js-custom-search-select')) {
                var div = $('<div>', {
                        'id': 'rfs-div-select-' + i,
                        'class': 'rfs-div-select',
                        'data-select-selector': '.rfs-select-' + i
                    }).css('width', $(this).css('width')),
                    title = $('<div>', {'class': 'rfs-div-select-title'}),
                    ul = $('<ul>').hide(),
                    li = null,
                    attr = null;
                $(this)
                    .hide()
                    .addClass('rfs-select-' + i)
                    .find('option').each(function () {
                    attr = {};
                    attr['data-value'] = $(this).val();
                    attr['title'] = ($(this).data('title')) ? $(this).data('title') : $(this).text();
                    if ($(this).prop('selected')) {
                        attr.class = 'active';
                        $(title).text($(this).text());
                    }
                    li = $('<li>', attr).text($(this).text());
                    $(ul).append(li);
                });
                $(this).after($(div).append(title, ul));
                rfs.select.upgradeLi('#' + $(div).attr('id'), title);
                rfs.select.upgradeTitle('#' + $(div).attr('id'));
            }
        });
    },
    'upgradeLi': function (selector, title) {
        $(selector).find('li').click(function () {
            var select = $($(selector).data('select-selector')),
                val = $(this).data('value');
            if ($(select).val() != val) {
                $(select).find('option').each(function () {
                    if ($(this).val() == val) {
                        $(select).val(val).change();
                        $(title).text($(this).text());
                    }
                });
                $(this).parent('ul').find('li.active').removeClass('active');
                $(this).addClass('active');
            }
        });
    },
    'upgradeTitle': function (selector) {
        $(selector).find('.rfs-div-select-title').click(function () {
            var ul = $(this).parent().find('ul');
            if (!$(selector).hasClass('open')) {

                $(document).find('.rfs-div-select').each(function () {
                    var $element = $(this);
                    var $list = $element.find('ul');
                    $element.removeClass('opening');
                    rfs.select.closeSelect($list, function () {
                        $element.removeClass('open');
                    });
                })

                $(selector).addClass('opening');
                rfs.select.openSelect(ul, function () {
                    $(selector).addClass('open');
                });
            } else {
                $(selector).removeClass('opening');
                rfs.select.closeSelect(ul, function () {
                    $(selector).removeClass('open');
                });
            }
            $('body').off('click');
            setTimeout(function () {
                $('body').click(function () {
                    $(selector).removeClass('opening');
                    rfs.select.closeSelect(ul, function () {
                        $(selector).removeClass('open');
                    });
                });
            }, rfs.select.delay);
        });
    },
    'openSelect': function (obj, callback) {
        $(obj).slideDown(rfs.select.delay, function () {
            callback();
        });
    },
    'closeSelect': function (obj, callback) {
        $('body').off('click');
        $(obj).slideUp(rfs.select.delay, function () {
            callback();
        });
    },
    'reinit': function () {
        $('.rfs-div-select').remove();
        rfs.select.init();
    }
};
rfs.checkbox = {
    'init': function () {
        $('label.rfs-checkbox').each(function () {
            if ($(this).find('input[type="checkbox"]').length) {
                var label = this,
                    original = $(this).find('input[type="checkbox"]'),
                    checkbox = $('<div>', {'class': 'rfs-checkbox-check'});
                if ($(original).prop('checked')) {
                    $(checkbox).addClass('checked')
                }
                if ($(original).prop('disabled')) {
                    $(checkbox).addClass('disabled')
                }
                $(original)
                    .after(checkbox)
                    .hide();
                $(checkbox).click(function () {
                    rfs.checkbox.upgrade(label, original)
                });
                $(label).children('span').click(function () {
                    rfs.checkbox.upgrade(label, original)
                });
            }
        });
    },
    'upgrade': function (label, original) {
        if (!$(original).prop('disabled')) {
            $(label).find('.rfs-checkbox-check').toggleClass('checked');
            //$(original).prop('checked', !$(original).prop('checked'));
        }
    }
};
rfs.accordion = {
    'init': function () {
        rfs.accordion.row.init();
        rfs.accordion.group.init();
        rfs.accordion.block.init();
    },
    'disable': false,
    'delay': 250,
    'row': {
        'init': function () {
            $(document).on('click', '.rfs-table-accordion .disperse', function () {
                if (!rfs.accordion.disable) {
                    var k = $('.rfs-table-accordion .disperse').index(this);

                    rfs.accordion.disable = true;
                    var el = $(this),
                        table = $(el).parents('.rfs-table-accordion').find($(el).data('disperse-selector'));
                    if (!$(el).hasClass('open')) {
                        var timeoutDelay = 0;
                        if ($(this).parents('.rfs-table-accordion').find('.disperse.open').length) {
                            rfs.accordion.disable = false;
                            $(this).parents('.rfs-table-accordion').find('.disperse.open').click();
                            timeoutDelay = rfs.accordion.delay;
                        }
                        setTimeout(function () {
                            $(el).addClass('open');
                            var top = $(el).position().top + $(el).outerHeight(),
                                heightTableBeforeAnimate = 0,
                                heightTable = 0,
                                countMatchTr = $(table).find('.js-disperse-tr').length;
                            $(table).find('.js-disperse-tr').each(function () {
                                if ($(table).data('type') === 'lineHeight') {
                                    heightTable += parseInt($(this).css('lineHeight'), 10);
                                } else {
                                    heightTable += parseInt($(this).css('height'), 10);
                                }
                            });
                            var paddingHeight = parseInt($(table).css('paddingTop'), 10) + parseInt($(table).css('paddingBottom'), 10);
                            if ($(table).data('type') === 'lineHeight') {
                                heightTable += paddingHeight;
                            }
                            var fakeTr = $('<tr>', {'class': 'fake-tr'}).css({'height': 0});
                            $(el).after($('<tr>', {'class': 'fake-tr-' + k}).css({'height': 0}), fakeTr);

                            $(fakeTr)
                                .animate({'height': heightTable + countMatchTr}, rfs.accordion.delay, 'linear');
                            $(table).css({'top': top}).show(0)
                                .animate({'height': heightTable + countMatchTr}, rfs.accordion.delay, 'linear', function () {
                                    rfs.accordion.disable = false;
                                });

                            var heightRightItems = parseInt($(table).find('.js-right-div-disperse').css('height'));

                            var isMobileDetected = MOBILE_DEVICE_REGEXP.test(navigator.userAgent);
                            if (isMobileDetected) {
                                var disperseTableItems = $(table).find('.js-disperse-tr');

                                // Получаем gap у свойства блока, в котором лежат элементы таблицы
                                var gapBetweenSections = parseInt($(table).children(0).css('gap'));

                                rfs.accordion.disable = true;

                                // Если у нас нет элементов в disperse-tr или же нет выооты правого блока, то gap будет 0;
                                var notRequiredGap = !disperseTableItems.length || !heightRightItems;
                                if (notRequiredGap) {
                                    gapBetweenSections = 0;
                                }

                                // Проходим по всем элементам js-disperse-tr и прибавляем к heightTableBeforeAnimate высоту элементов
                                disperseTableItems.each(function () {
                                    heightTableBeforeAnimate += parseInt($(this).css('height'), 10);
                                });
                                heightTableBeforeAnimate += paddingHeight;

                                // Высчитываем высоту (высота таблицы с паддингами + gap + высоту правого блока + количество элементов tr
                                var computedHeight = heightTableBeforeAnimate + gapBetweenSections + heightRightItems + countMatchTr;
                                $(fakeTr).animate({'height': computedHeight}, rfs.accordion.delay, 'linear');
                                $(table).css({'top': top})
                                    .show(0)
                                    .animate({'height': computedHeight}, rfs.accordion.delay, 'linear', function () {
                                        rfs.accordion.disable = false;
                                    });
                            } else {
                                if (heightTable < heightRightItems) {
                                    rfs.accordion.disable = true;
                                    $(fakeTr)
                                        .animate({'height': heightRightItems + paddingHeight + countMatchTr}, rfs.accordion.delay, 'linear');
                                    $(table).css({'top': top}).show(0)
                                        .animate({'height': heightRightItems + paddingHeight + countMatchTr}, rfs.accordion.delay, 'linear', function () {
                                            rfs.accordion.disable = false;
                                        });
                                } else {
                                    rfs.accordion.disable = true;
                                    $(table).find('.js-disperse-tr').each(function () {
                                        heightTableBeforeAnimate += parseInt($(this).css('height'), 10);
                                    });
                                    heightTableBeforeAnimate += paddingHeight;
                                    $(fakeTr)
                                        .animate({'height': heightTableBeforeAnimate + countMatchTr}, rfs.accordion.delay, 'linear');
                                    $(table).css({'top': top}).show(0)
                                        .animate({'height': heightTableBeforeAnimate + countMatchTr}, rfs.accordion.delay, 'linear', function () {
                                            rfs.accordion.disable = false;
                                        });
                                }
                            }
                        }, timeoutDelay);
                    } else {
                        $(el).removeClass('open');
                        $(el).parent().find('.fake-tr').animate({'height': 0}, rfs.accordion.delay, 'linear', function () {
                            $('.fake-tr-' + k).remove();
                            $(this).remove();
                        });
                        $(table).animate({'height': 0}, rfs.accordion.delay, 'linear', function () {
                            $(this).hide(0);
                            rfs.accordion.disable = false;
                        });
                    }
                }
            });
        }
    },
    'group': {
        'init': function () {
            $('.accordion-group').find('.accordion-btn').click(function () {
                var el = this;
                var group = $(this).parents('.accordion-group');
                var selector = $(this).data('accordion-selector');
                if (!$(this).parent().hasClass('active')) {
                    rfs.accordion.group.closeAll(group, function () {
                        rfs.accordion.group.open(el, group, selector);
                    });
                } else {
                    rfs.accordion.group.closeAll(group);
                }
            });
        },
        'open': function (el, group, selector) {
            $(el).parent().addClass('active');
            $(group).find(selector).addClass('open').slideDown(rfs.accordion.delay);
        },
        'closeAll': function (group, callback) {
            if ($(group).find('.accordion-item.open').length) {
                $(group).find('.accordion-btn').parent('.active').removeClass('active');
                $(group).find('.accordion-item.open').removeClass('open').slideUp(rfs.accordion.delay, function () {
                    if (callback) {
                        callback();
                    }
                });
            } else if (callback) {
                callback();
            }
        }
    },
    'block': {
        'init': function () {
            $('.accordion-block').find('.accordion-btn-block').click(function () {
                var selector = $(this).data('accordion-selector');
                if ($(selector).length) {
                    var block = $(selector);
                    if ($(block).hasClass('open')) {
                        $(block).removeClass('open').slideUp(rfs.accordion.delay);
                        $(this).parent().addClass('active');
                    } else {
                        $(block).addClass('open').slideDown(rfs.accordion.delay);
                        //rfs.accordion.block.goToElem(this);
                        $(this).parent().removeClass('active');
                    }
                }
            });
        },
        'goToElem': function (el) {
            $('html, body').animate({
                scrollTop: ($(el).offset().top - 69)
            }, rfs.accordion.delay, false);
        }
    }
};
rfs.dropdown = {
    'init': function () {
        $('ul.rfs-dropdown').each(function (k) {
            var dropdown = $('<div>', {'class': 'rfs-dropdown'});
            if ($(this).hasClass('disabled')) {
                $(dropdown).addClass('disabled');
            }
            if ($(this).hasClass('rfs-dropdown-left')) {
                $(dropdown).addClass('rfs-dropdown-left');
            }
            var dropdown_title = $('<a>', {'class': 'rfs-dropdown-title'}),
                select = $('<select>', {'id': 'rfs-dropdown-' + k});
            if ($(this).data('name')) {
                $(select).attr('name', $(this).data('name'));
            }
            if (!$(this).data('default-title')) {
                var flag = false, option;
                $(this).find('li').each(function () {
                    option = $('<option>', {'value': $(this).html()}).html($(this).html());
                    var prefix = $(this).data('param-filter-prefix') || '';

                    if ($(this).hasClass('active') && !flag) {
                        flag = true;
                        $(dropdown_title).html(prefix + ' ' + $(this).html());

                        $(option).prop('selected', true);
                    }
                    $(select).append(option);
                });
                if (!flag) {
                    $(dropdown_title).html($(this).find('li:first-child').html());
                }
            } else {
                $(dropdown_title).html($(this).data('default-title'));
            }
            $(document).on('click', function (event) {
                rfs.dropdown.closeOtherDropDown();
                if ($(event.target).hasClass('rfs-dropdown-title') || $(event.target).closest('.rfs-dropdown-title').length > 0) {
                    var $dropdown = $(event.target).closest('.rfs-dropdown');
                    if ($dropdown && !$dropdown.hasClass('disabled')) {
                        rfs.dropdown.open($dropdown);
                    }
                } else {
                    if ($(dropdown.closest('.js-dropdown-content-no-overflow')) && $(dropdown).closest('.js-content-for-dropdown')) {
                        $(dropdown).closest('.js-content-for-dropdown').removeClass('dropdown-open');
                    }
                }
            });

            var clone = $(this).clone().removeClass('rfs-dropdown');
            $(clone).find('li').each(function () {
                $(this).click(function () {
                    rfs.dropdown.upgrade(this, k);
                });
            });

            $(dropdown).append(dropdown_title, clone);
            rfs.dropdown.blockLinkInTitle(dropdown_title);
            $(this).replaceWith(dropdown);
            $(dropdown).after($(select).hide());
        });
    },

    'closeOtherDropDown': function () {
        $('.rfs-dropdown').removeClass('open');
    },
    'open': function (dropdown) {
        $(dropdown).toggleClass('open');
        if ($(dropdown.closest('.js-dropdown-content-no-overflow')) && $(dropdown).closest('.js-content-for-dropdown')) {
            $(dropdown).closest('.js-content-for-dropdown').addClass('dropdown-open');
        }
        setTimeout(function () {
            $('body').off('click').click(function () {
                $('body').off('click');
            });
        }, 1);
    },
    'upgrade': function (el, k) {
        var parent = $(el).parent();
        var dropdown = $(el).parents('.rfs-dropdown');
        if (!$(el).hasClass('active')) {
            if (!$(parent).data('close-click')) {
                $(dropdown).find('ul>li.active').removeClass('active');
                var dropdown_title = $(dropdown).removeClass('open').find('.rfs-dropdown-title');
                var $filterItem = $(el).closest('.rfs-filters-item');
                var prefix = '';

                if ($filterItem.length && $filterItem.data('param-filter-prefix')) {
                    prefix = $filterItem.data('param-filter-prefix');
                }

                $(dropdown_title).html(prefix + ' ' + $(el).html());
                rfs.dropdown.blockLinkInTitle(dropdown_title);
            }
            $(el).addClass('active');
            $('body').off('click');
        } else {
            if ($(dropdown).find('ul>li').length < 2) {
                $(dropdown).removeClass('open');
            } else {
                $(el).removeClass('active');
            }
        }
        var val = $(el).html(), select = $('#rfs-dropdown-' + k);
        $(select).find('option').each(function () {
            if ($(this).val() == val) {
                $(this).prop('selected', true);
                $(select).change();
            }
        });
    },
    'blockLinkInTitle': function (dropdown_title) {
        $(dropdown_title).find('a').click(function (event) {
            event = event || window.event;
            event.preventDefault();
        });
    }
};
rfs.descmore = {
    'init': function () {
        $('.desc-more').each(function () {
            var target = $(this).parents($(this).data('target')),
                parent = $(this).parent(),
                max_height = $(this).data('maxHeight') - 50;
            $(parent).css({
                'overflow': 'hidden',
                'maxHeight': max_height,
                'position': 'relative'
            });
            /*if (parseInt($(parent).css('paddingBottom'), 10) > 0) {
             max_height = max_height + parseInt($(parent).css('paddingBottom'), 10) - 16;
             }*/
            $(this)
                .css({'top': max_height - 50})
                .click(function () {
                    $(this).remove();
                    $(target).css({
                        'overflowY': 'scroll',
                        'maxHeight': $(target).outerHeight()
                    });
                    $(parent).css({
                        'overflow': 'hidden',
                        'maxHeight': 'inherit'
                    });
                });
        });
    }
};
rfs.mobileSlider = {
    'params': {},
    'init': function () {
        var mobile = ($('.wrapper').outerWidth() < 481);
        rfs.mobileSlider.params.padding = rfs.mobileSlider.getPadding();
        rfs.mobileSlider.params.slider = $('.main-slider');
        rfs.mobileSlider.eventWrapper(mobile);
        $(rfs.mobileSlider.params.slider).on('init', function (event, slick, currentSlide, nextSlide) {
            $(this).show();
        });
        $(rfs.mobileSlider.params.slider).slick(rfs.mobileSlider.getOpts(mobile))
    },
    'getPadding': function () {
        return ($(window).width() - 1170) / 2;
    },
    'getOpts': function (mobile) {
        var slidesToScroll = 1;
        if (mobile) {
            return {
                centerPadding: 0,
                slidesToShow: 1,
                speed: 700,
                slidesToScroll: slidesToScroll,
                autoplay: true,
                autoplaySpeed: 7000,
                dots: true,
                arrows: false,
            }
        } else {
            if (rfs.mobileSlider.params.padding >= 1170 * 3) {
                slidesToScroll = 3;
            }

            var leftArrowPos = rfs.mobileSlider.params.padding + 380 - 33,
                rightArrowPos = (rfs.mobileSlider.params.padding + 1);
            if ($(window).width() <= 1170) {
                leftArrowPos = 380 - 33;
                rightArrowPos = 0;
            }

            return {
                centerMode: true,
                centerPadding: rfs.mobileSlider.params.padding + 'px',
                slidesToShow: 1,
                accessibility: false,
                speed: 700,
                slidesToScroll: slidesToScroll,
                autoplay: true,
                autoplaySpeed: 7000,
                dots: true,
                prevArrow: '<i class="slick-arrow slick-prev fa fa-chevron-left" style="right: ' + leftArrowPos + 'px;"></i>',
                nextArrow: '<i class="slick-arrow slick-next fa fa-chevron-right" style="right: ' + rightArrowPos + 'px;"></i>'
            }
        }
    },

    'eventWrapper': function (mobile) {
        $(rfs.mobileSlider.params.slider)
            .show(0)
            .off(rfs.mobileSlider.getEventsObj(mobile))
            .on(rfs.mobileSlider.getEventsObj(mobile));
    },
    'getEventsObj': function (mobile) {
        return (mobile) ? {} : {
            'init': rfs.mobileSlider.events.init,
            'beforeChange': rfs.mobileSlider.events.beforeChange,
            'afterChange': rfs.mobileSlider.events.afterChange
        };
    },
    'events': {
        'init': function () {
            var dotsPos = rfs.mobileSlider.params.padding - 32 + 85;
            if ($(window).width() <= 1170) {
                dotsPos = 48;
            }
            $('.slick-dots').css('right', dotsPos);
            $(rfs.mobileSlider.params.slider).find('.main-slider-slide').click(function () {
                if ($(this).prev().hasClass('slick-current')) {
                    $(rfs.mobileSlider.params.slider).slick('slickNext');
                } else if ($(this).next().hasClass('slick-current')) {
                    $(rfs.mobileSlider.params.slider).slick('slickPrev');
                }
            });
            $(window).off("resize", rfs.mobileSlider.events.resizeInit);
            $(window).resize(rfs.mobileSlider.events.resizeInit);
        },
        'resizeInit': function () {
            clearTimeout(rfs.mobileSlider.params.resizedFinished);
            rfs.mobileSlider.params.resizedFinished = setTimeout(function () {
                $(rfs.mobileSlider.params.slider).slick('unslick');
                rfs.mobileSlider.init();
            }, 250);
        },
        'beforeChange': function () {
            $(rfs.mobileSlider.params.slider).find('.slick-arrow, .slick-dots').fadeOut(250);
        },
        'afterChange': function () {
            $(rfs.mobileSlider.params.slider).find('.slick-arrow, .slick-dots').fadeIn(150);
        }
    }
};
rfs.mainSlider = new function () {
    var that = this;

    var timer;

    var slider = $('.js-news-slider'),
        leadList = $(slider).find('.js-news-slider-lead-list'),
        leads = $(leadList).find('.js-news-slider-box'),
        imageList = $(slider).find('.js-news-slider-image-list'),
        images = $(imageList).find('.js-news-slider-box');

    var params = {
        'nicescrollCfg': {
            'cursorcolor': '#d50028',
            'cursoropacitymin': 0,
            'cursoropacitymax': 1,
            'cursorwidth': '3px',
            'cursorborder': 'none',
            'cursorborderradius': '2px',
            'zindex': '99999',
            'scrollspeed': '0',
            'autohidemode': false,
            'railoffset': {
                'left': -2
            }
        }
    };

    this.init = function () {
        var activeIndex = that.getIndexActiveBox();
        $(leads[activeIndex]).addClass('js-preview');
        that.customize.lead(leads[activeIndex]);

        $(imageList).find(':not(js-show)');
        $(images[activeIndex]).addClass('js-show');

        $(leads).click(function () {
            that.changePreview(this, false);
        });

        //that.setNiceScroll();
        that.setTimer();
    };

    that.changePreview = function (el, clear) {
        if (!$(el).hasClass('js-preview')) {
            $(leadList).find('.js-preview').each(function () {
                $(this).removeClass('js-preview');
                that.customize.lead(this);
            });
            $(el).addClass('js-preview');
            that.customize.lead(el);

            $(imageList).find('.js-show').each(function () {
                $(this).removeClass('js-show');
            });
            $(images[$(el).index()]).addClass('js-show');

            var activeIndex = that.getIndexActiveBox();
            that.leadListScroll(activeIndex, clear);
            that.imageListScroll(activeIndex);
        }
    };

    that.leadListScroll = function (index, clear) {
        if (!clear) {
            clearInterval(timer);
            setTimeout(function () {
                that.setTimer();
            }, 10000);
        }

        if (index > 2) {
            var scrollTop = $(leadList).scrollTop();
            $(leadList).animate({scrollTop: scrollTop + 98}, 500);
        }
        if (index == 0) {
            $(leadList).animate({scrollTop: 0}, 300);
        }
    };

    that.imageListScroll = function (index) {
        if (index == 0) {
            $(imageList).animate({scrollTop: 0}, 300);
        } else {
            $(imageList).animate({scrollTop: index * 506}, 500);
        }
    };

    this.setNiceScroll = function () {
        $(leadList).niceScroll(params.nicescrollCfg);
        $(imageList).niceScroll(params.nicescrollCfg);
    };

    this.setTimer = function () {
        clearInterval(timer);
        timer = setInterval(function () {
            var activeIndex = that.getIndexActiveBox(),
                nextIndex = (activeIndex < $(leads).length - 1) ? activeIndex + 1 : 0;
            that.changePreview(leads[nextIndex], true);
        }, 5000);
    };

    this.getIndexActiveBox = function () {
        var activeIndex = 0;
        $(leads).each(function (i) {
            if ($(this).hasClass('js-preview')) {
                activeIndex = i;

                return false;
            }
        });

        return activeIndex;
    };

    this.customize = {
        lead: function (el) {
            if ($(el).hasClass('js-preview')) {
                $(el).addClass('slider__text-item--active');
            } else {
                $(el).removeClass('slider__text-item--active');
            }
        }
    };
};
rfs.locker = {
    'lock': function (el) {
        $(el).prop('disabled', true);
        $(el).append($('<span>', {'class': 'rfs-lock'}).html(
            '<div id="circleG_1" class="circleG"></div>' +
            '<div id="circleG_2" class="circleG"></div>' +
            '<div id="circleG_3" class="circleG"></div>'
        ));


        $(el).data('default-color', $(el).css('color'));
        $(el).css('color', 'transparent');
    },
    'unlock': function (el) {
        $(el).prop('disabled', false);
        $(el).find('span.rfs-lock').remove();

        $(el).css('color', $(el).data('default-color'));
        $(el).removeAttr('default-color');
    }
};
rfs.overlay = {
    'create': function () {
        if (!$('.overlay').length) {
            $('body').append($('<div>', {'class': 'overlay'}).hide());
        }
    },
    'open': function () {
        $('.overlay').show();
    },
    'close': function () {
        $('.overlay').hide();
    }
};
rfs.sorttable = {
    'init': function () {
        $('.js-sorttable').each(function (index, el) {

            var mainSortDirection = $(this).data('sortinitialorder');

            if (typeof $(el).data('tablesorter') === 'undefined') {
                var data = $(el).data(),
                    params = {
                        sortRestart: true,
                        'headers': {},
                    };

                if (data.headers) {
                    params.headers = data.headers;
                } else {
                    $(el).find('thead th').each(function (i) {
                        if (!$(this).hasClass('js-sort')) {
                            params.headers[i] = {'sorter': false};
                        }

                        var columnSortDirection = $(this).data('sortinitialorder');
                        if (columnSortDirection) {
                            params.headers[i] = {
                                sortInitialOrder: columnSortDirection
                            }
                        } else {
                            params.headers[i] = {
                                sortInitialOrder: mainSortDirection
                            }
                        }
                    });
                }

                params.textExtraction = function (cell) {
                    if ($(cell).data('sortValue')) {
                        return $(cell).data('sortValue');
                    }
                    return $(cell).text() === '-' ? '-1' : $(cell).text();
                };

                $(el).data('tablesorter', $(el).tablesorter(params))
                    .bind('sortEnd', function () {
                        if ($(this).data('sortedclass')) {
                            rfs.sorttable.changeColumnSorted($(this))
                        }
                    });
            }
        });
    },

    "changeColumnSorted": function (block) {
        var $headers = block.find('th');

        var sortedSettings = rfs.sorttable.returnIndexClassInHeaders($headers);
        rfs.sorttable.removeSortedClass(block);
        rfs.sorttable.addClassRequiredCeils(block, sortedSettings);
    },

    "returnIndexClassInHeaders": function (headers) {
        var result;
        var addIndex = 0;
        var colspanIndex;
        var elementIndex;
        // headerSortUp headerSortUp - старые классы
        headers.each(function (index, element) {
            if ($(element).attr('colspan')) {
                addIndex = Number($(element).attr('colspan')) - 1;
                colspanIndex = index;
            }
            if ($(element).hasClass('tablesorter-headerDesc')) {
                elementIndex = index;
                if (colspanIndex && index >= colspanIndex) {
                    elementIndex += addIndex
                }
                result = {
                    class: 'headerSortUp',
                    number: elementIndex
                };
            }

            if ($(element).hasClass('tablesorter-headerAsc')) {
                elementIndex = index;
                if (colspanIndex && index >= colspanIndex) {
                    elementIndex += addIndex
                }
                result = {
                    class: 'headerSortDown',
                    number: elementIndex
                }
            }

        });
        return result
    },

    'removeSortedClass': function (block) {
        var $body = block.find('tbody');
        var $ceils = $body.find('td');
        var $head = block.find('thead');
        var $headCeils = $head.find('th');

        $ceils.removeClass('headerSortUp');
        $ceils.removeClass('active');
        $ceils.removeClass('headerSortDown');
        $headCeils.removeClass('asc');
        $headCeils.removeClass('desc');

    },

    'addClassRequiredCeils': function (block, settings) {
        var $body = block.find('tbody');
        var $line = $body.find('tr');
        $line.each(function (index, element) {
            $(element).find('td').eq(settings.number).addClass(settings.class)
        })
    }
};


rfs.mobile = {};
rfs.mobile.init = function () {
    rfs.mobile.menu.init();
    rfs.mobile.swipebox.init();
    //JS Матчи сборной
    if ($('.matches-swiper').length) {
        $('.matches-swiper')
            .on('init', function (event, slick, currentSlide, nextSlide) {
                $(this).show();
            })
            .slick({
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                mobileFirst: true
            });
    }
};
rfs.mobile.menu = {
    'init': function () {
        rfs.mobile.menu.headerMenuInit();
        if ($('#RFSMainSubMenuMobile').length) {
            rfs.mobile.menu.titleMenuInit();
        }
    },
    'headerMenuInit': function () {
        $('.header-humburger').click(function () {
            if (!$('.header').hasClass('open')) {
                rfs.mobile.menu.headerMenuOpen();
            } else {
                rfs.mobile.menu.headerMenuClose();
            }
        });

        $('.header-menu>ul').find('a').click(function () {
            rfs.mobile.menu.initItem(this, '.header-menu');
        });
    },
    'headerMenuOpen': function () {
        $('.header').addClass('open');
        $('.header-menu').animate({'left': 0, 'opacity': 1}, 200);
    },
    'headerMenuClose': function () {
        $('.header').removeClass('open');
        $('.header-menu').animate({'left': -480, 'opacity': 0}, 200);
    },
    'titleMenuInit': function () {
        if (!$('#RFSMainSubMenuMobile').find('ul.submenu').length) {
            $('.main-title-menu>ul>li').css('width', '100%');
        }

        $('.main-title.with-menu').click(function () {
            if (!$(this).hasClass('open')) {
                rfs.mobile.menu.titleMenuOpen();
            } else {
                rfs.mobile.menu.titleMenuClose();
            }
        });

        $('.main-title-menu>ul').find('a').click(function () {
            rfs.mobile.menu.initItem(this, '.main-title-menu');
        });
    },
    'titleMenuOpen': function () {
        $('.main-title.with-menu').addClass('open');
        $('.main-title-menu').addClass('open').slideDown(200);
    },
    'titleMenuClose': function () {
        $('.main-title.with-menu').removeClass('open');
        $('.main-title-menu').removeClass('open').slideUp(200);
    },
    'openSubMenu': function (el, menu_selector) {
        var menu = $(menu_selector);
        var countOpen = $(menu).find('.has-submenu.active');
        if ($(countOpen).length) {
            $(countOpen).each(function () {
                var callback = null;
                if (!$(el).parent().hasClass('active')) {
                    callback = function () {
                        rfs.mobile.menu.openSubMenu(el);
                    }
                }
                rfs.mobile.menu.closeSubMenu($(this).children('a'), callback);
            });
        } else {
            $('.header-menu>ul>li.active').removeClass('active');

            $('.header-menu').addClass('open');
            $(el).parent().addClass('active');
            $(el).parent().find('ul.submenu').show().animate({'left': '50%', 'opacity': 1}, 200);
            if (!$(el).parent().hasClass('has-submenu')) {
                rfs.mobile.menu.headerMenuClose();
            }
        }
    },
    'closeSubMenu': function (el, callback) {
        $('.header-menu').removeClass('open');
        $(el).parent().removeClass('active');
        $(el).parent().find('ul.submenu').animate({'left': '0', 'opacity': 0}, 200, function () {
            $(this).hide();
            if (callback) {
                callback();
            }
        });
    },
    'initItem': function (el, menu_selector) {
        rfs.mobile.menu.openSubMenu(el, menu_selector);
        if ($(el).parent().hasClass('.has-submenu')) {
            $(el).parent().find('ul.submenu a').click(function () {
                var submenu = $(this).parents('ul.submenu');
                $(submenu).find('li.active').removeClass('active');
                $(this).parent().addClass('active');
                rfs.mobile.menu.headerMenuClose();
            });
        }
    }
};
rfs.mobile.swipebox = {
    'params': {
        'layoutWidth': $('.wrapper').outerWidth()
    },
    'init': function () {
        $('.rfs-swipe').each(function () {
            var left,
                el = $(this).children('ul').first().get(0),
                width = $(this).width();

            new Hammer(el, {domEvents: true});

            $(el).on('panstart', function (e) {
                left = parseInt($(this).css('left'), 10);
            });

            $(el).on('pan', function (e) {
                var offset = left + e.originalEvent.gesture.deltaX;
                if (offset <= 1 && ($(el).width() - width) > -offset) {
                    $(this).css({
                        'left': offset
                    });
                }
            });
        });
    }
};

function clone(o) {
    if (!o || "object" !== typeof o) {
        return o;
    }
    var c = "function" === typeof o.pop ? [] : {};
    var p, v;
    for (p in o) {
        if (o.hasOwnProperty(p)) {
            v = o[p];
            if (v && "object" === typeof v) {
                c[p] = clone(v);
            } else c[p] = v;
        }
    }
    return c;
}

function in_array(needle, haystack, strict) {
    var found = false, key, strict = !!strict;
    for (key in haystack) {
        if ((strict && haystack[key] === needle) || (!strict && haystack[key] == needle)) {
            found = true;
            break;
        }
    }
    return found;
}

/**
 * Класс для фотогалереи
 * @param options - объект с настройками
 * @returns {PhotoPopup}
 * @constructor
 */
var PhotoPopup = function (options) {
    var defaults = {
        ajaxUrl: '',
        totalCount: 0,
        popupClass: 'photo-popup',
        popupOverlayClass: 'photo-popup-overlay',
        popupContentClass: 'photo-popup-content',
        btnCloseClass: 'photo-popup-btn-close',
        btnPrevClass: 'photo-popup-btn-prev',
        btnNextClass: 'photo-popup-btn-next',
        photoListContainerSelector: '.js-photo-list-container',
        photoListSelector: '.js-photo-list',
        photoListItemSelector: '.js-photo-list-item',
        photoLinkSelector: '.js-photo-popup',
        loadMoreBtnSelector: '.js-load-more',
        loaderSelector: '.js-photo-list-loader',
        photoTemplateSelector: '.js-photo-list-item-tpl',
        photoLinkText: 'Ссылка на фотографию',
        albumLinkText: 'Перейти к альбому'
    };
    var settings = $.extend({}, defaults, options);

    var $popup = $('<div>', {
        class: settings.popupOverlayClass,
        append: $('<div>', {
            class: settings.popupClass,
            append: [
                $('<button>', {
                    type: 'button',
                    class: settings.btnCloseClass
                }),
                $('<div>', {
                    class: settings.popupContentClass
                }),
                $('<button>', {
                    type: 'button',
                    class: settings.btnPrevClass
                }),
                $('<button>', {
                    type: 'button',
                    class: settings.btnNextClass
                })
            ]
        })
    });
    var $btnClose = $popup.find('.' + settings.btnCloseClass);
    var $btnPrev = $popup.find('.' + settings.btnPrevClass);
    var $btnNext = $popup.find('.' + settings.btnNextClass);

    var $container = $(settings.photoListContainerSelector);
    var $masonryContainer = $container.find('.js-masonry');
    var $btnLoadMore = $container.find(settings.loadMoreBtnSelector);
    var $loader = $container.find(settings.loaderSelector);

    var $photoTemplate = $container.find(settings.photoTemplateSelector);
    var $photoList = $container.find(settings.photoListSelector);
    var photoCount = 0;

    /**
     * Инициализация
     */
    var init = function () {
        // Добавление разметки попапа на страницу
        $popup.appendTo('body');

        // Обработка событий

        // Клик по элементу галереи
        $(document).on('click', settings.photoLinkSelector, function (e) {
            e.preventDefault(); // предотвращаем переход по ссылке
            var $currentItem = $(this).closest(settings.photoListItemSelector);
            activateItemByIndex($currentItem.index());
            $popup.addClass('active');
        });

        // Клик вне попапа / по кнопке закрытия
        $(document).on('click', function (e) {
            var $target = $(e.target);
            if ($target.is($btnClose) || $target.is($popup)) {
                closePopup();
            }
        });

        // Клик на кнопки переключения изображений
        $btnPrev.on('click', prevItem);
        $btnNext.on('click', nextItem);

        // Если доступна библиотека Hammer.js - используем её для подписки на свайпы
        if (typeof Hammer !== 'undefined') {
            var swipeContainer = new Hammer($popup.get(0));
            swipeContainer.on('swipeleft', nextItem);
            swipeContainer.on('swiperight', prevItem);
        }

        $container.on('click', settings.loadMoreBtnSelector, function () {
            loadPhotos();
        });
        loadPhotos();
    };

    /**
     * Отрисовка фотографий
     * @param photos
     */
    var renderPhotos = function (photos) {
        if (typeof photos.forEach === 'function') {
            photos.forEach(function (photo) {
                var $newPhotoContainer = $photoTemplate.clone();
                var $newPhoto = $newPhotoContainer.find(settings.photoLinkSelector);
                var orientCssClass = photoCount % 2 ? 'vertical' : 'horizontal';

                $newPhotoContainer.addClass(orientCssClass);
                $newPhoto.data({
                    imgUrl: photo.src,
                    albumUrl: photo.albumUrl,
                    title: photo.description || '-',
                    author: photo.author
                });
                $newPhoto.attr('href', photo.detailUrl);
                $newPhoto.css('background-image', 'url(' + photo.src + ')');

                $newPhotoContainer.appendTo($photoList).show();
                photoCount++;

                if (typeof Masonry !== 'undefined') {
                    $photoList.masonry('appended', $newPhotoContainer);
                }
            });
            if (typeof Masonry !== 'undefined') {
                $photoList.masonry('layout');
            }
        }
    };

    /**
     * Загрузка следующей страницы фоток
     */
    var loadPhotos = function () {
        if (settings.ajaxUrl) {
            $.ajax({
                url: settings.ajaxUrl,
                method: 'GET',
                data: {},
                beforeSend: function () {
                    $loader.fadeIn();
                },
                success: function (response) {
                    $loader.fadeOut();

                    if (response.photos) {
                        renderPhotos(response.photos);
                    }
                    if (response.nextUrl) {
                        settings.ajaxUrl = response.nextUrl;
                    } else {
                        settings.ajaxUrl = null;
                        $btnLoadMore.fadeOut();
                    }
                },
                error: function (response) {
                    console.log('response error: ' + response.message);
                }
            });
        }
    };

    /**
     * Установка изображения
     * @param imgSrc - адрес изображения
     */
    var setImg = function (imgSrc) {
        var $img = $('<img>', {
            src: imgSrc,
            alt: '',
            css: {
                opacity: 0
            },
            on: {
                'load': function () {
                    $(this).css('opacity', 1);
                }
            }
        });

        $popup.find('.' + settings.popupContentClass).empty().append($img);
    };

    var setContent = function (content) {
        var $container = $popup.find('.' + settings.popupContentClass);
        $container.css({
            width: '',
            height: ''
        });
        var $content = [
            $('<img>', {
                src: content.imgUrl,
                alt: '',
                css: {
                    opacity: 0
                },
                on: {
                    'load': function () {
                        var $img = $(this);
                        $img.css({
                            opacity: 1
                        });
                        $container.css({
                            width: $img.width(),
                            height: $img.height()
                        });
                    }
                }
            }),
            $('<div>', {
                class: 'photo-popup-info-wrap',
                append: $('<div>', {
                    class: 'photo-popup-info',
                    append: [
                        $('<div>', {
                            class: 'photo-info-main',
                            append: [
                                $('<p>', {
                                    class: 'photo-info-title',
                                    text: content.title
                                }),
                                $('<p>', {
                                    class: 'photo-info-author',
                                    text: content.author
                                })
                            ]
                        }),
                        $('<div>', {
                            class: 'photo-info-links',
                            append: [
                                $('<p>', {
                                    class: 'photo-info-link',
                                    append: $('<a>', {
                                        href: content.imgUrl,
                                        text: settings.photoLinkText,
                                        target: '_blank'
                                    })
                                }),
                                $('<p>', {
                                    class: 'photo-info-album',
                                    append: $('<a>', {
                                        href: content.albumUrl,
                                        text: settings.albumLinkText
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ];

        $container.empty().append($content);
    }

    /**
     * Показать изображение для элемента галереи по номеру элемента
     * @param index - номер элемента галереи
     */
    var activateItemByIndex = function (index) {
        var $items = $photoList.find(settings.photoListItemSelector);

        $btnPrev.prop('disabled', false);
        $btnNext.prop('disabled', false);

        if (index - 1 < 0) {
            $btnPrev.prop('disabled', true);
        } else if (index + 1 >= $items.length) {
            if (settings.ajaxUrl) {
                loadPhotos();
            } else {
                $btnNext.prop('disabled', true);
            }
        }

        if (index >= 0 && index < $items.length) {
            $items.removeClass('current').eq(index).addClass('current');
            // setImg($items.eq(index).find(settings.photoLinkSelector).data('imageUrl'));
            setContent($items.eq(index).find(settings.photoLinkSelector).data());
        }
    };

    /**
     * Показать изображение для предыдущего элемента
     */
    var prevItem = function () {
        var currentIndex = $(settings.photoListItemSelector).filter('.current').index();
        $btnPrev.blur();
        activateItemByIndex(currentIndex - 1);
    };

    /**
     * Показать изображение для следующегно элемента
     */
    var nextItem = function () {
        var currentIndex = $(settings.photoListItemSelector).filter('.current').index();
        $btnNext.blur();
        activateItemByIndex(currentIndex + 1);
    };

    /**
     * Закрыть попап
     */
    var closePopup = function () {
        $popup.removeClass('active');
        $popup.find('.' + settings.popupContentClass).empty();
    };

    /**
     * Вызов инициализации
     */
    init();

    /**
     * Публичные методы
     */
    this.activateItemByIndex = activateItemByIndex;
    this.prevItem = prevItem;
    this.nextItem = nextItem;

    return this;
};
